module.exports = __webpack_public_path__ + "b52a14e98b7f300ae4d47fe33bcaeae4.png";